import reducer from "./reducer";
export { default as MyCertificatesAndReceiptsDialog } from "./components/index";
export { default as myDocumentsReducerName } from "./constants";
export default reducer;
